<template>
  <b-form-row class="mb-2">
    <b-col
      v-if="earningStats.showTodayPropertyStats"
      class="mb-1 mb-lg-0"
    >
      <EarningStatistic
        :current-value="earningStats.today"
        one-value-mode
        :loading="loadingEarningStats"
      >
        <template v-slot:primary-text>
          {{ $tk('ClientPortal.Property.Earnings.Today') }}
        </template>
      </EarningStatistic>
    </b-col>
    <b-col
      v-else
      class="mb-1 mb-lg-0"
    >
      <EarningStatistic
        :current-value="earningStats.yesterday"
        one-value-mode
        :loading="loadingEarningStats"
      >
        <template v-slot:primary-text>
          {{ $tk('ClientPortal.Property.Earnings.Yesterday') }}
        </template>
      </EarningStatistic>
    </b-col>
    <b-col
      v-if="earningStats.showTodayPropertyStats"
      class="mb-1 mb-lg-0"
    >
      <EarningStatistic
        :current-value="earningStats.yesterday"
        :previous-value="earningStats.yesterdayLastWeek"
        :loading="loadingEarningStats"
      >
        <template v-slot:primary-text>
          {{ $tk('ClientPortal.Property.Earnings.Yesterday') }}
        </template>
        <template v-slot:secondary-text>
          {{ $tk('ClientPortal.Property.Earnings.VsSameDayLastWeek') }}
        </template>
      </EarningStatistic>
    </b-col>
    <b-col
      v-else
      class="mb-1 mb-lg-0"
    >
      <EarningStatistic
        :current-value="earningStats.dayBeforeYesterday"
        :previous-value="earningStats.yesterdayLastWeek"
        :loading="loadingEarningStats"
      >
        <template v-slot:primary-text>
          {{ $tk('ClientPortal.Property.Earnings.DayBeforeYesterday') }}
        </template>
        <template v-slot:secondary-text>
          {{ $tk('ClientPortal.Property.Earnings.VsSameDayLastWeek') }}
        </template>
      </EarningStatistic>
    </b-col>
    <b-col
      class="mb-1 mb-lg-0"
    >
      <EarningStatistic
        :current-value="earningStats.last7Days"
        :previous-value="earningStats.previous7Days"
        :loading="loadingEarningStats"
      >
        <template v-slot:primary-text>
          {{ $tk('ClientPortal.Property.Earnings.Last7Days') }}
        </template>
        <template v-slot:secondary-text>
          {{ $tk('ClientPortal.Property.Earnings.VsPrevious7days') }}
        </template>
      </EarningStatistic>
    </b-col>
    <b-col
      class="mb-1 mb-lg-0"
    >
      <EarningStatistic
        :current-value="earningStats.last28Days"
        :previous-value="earningStats.previous28Days"
        :loading="loadingEarningStats"
      >
        <template v-slot:primary-text>
          {{ $tk('ClientPortal.Property.Earnings.Last28Days') }}
        </template>
        <template v-slot:secondary-text>
          {{ $tk('ClientPortal.Property.Earnings.VsPrevious28days') }}
        </template>
      </EarningStatistic>
    </b-col>
    <b-col>
      <b-card
        class="h-100 mb-0"
        bg-variant="primary"
        body-class="p-1"
      >
        <small class="text-light">{{ $tk('ClientPortal.Account.Balance') }}</small>
        <h4 class="text-light">
          {{ earningStats.balance | formatCurrency }}
        </h4>
        <small class="text-light">{{ $tk('ClientPortal.Property.Earnings.LastPayment') }}</small>
        <h4 class="text-light mb-0">
          {{ earningStats.lastPayment | formatCurrency }}
        </h4>
      </b-card>
    </b-col>
  </b-form-row>
</template>

<script>
import EarningStatistic from './EarningStatistic.vue'

export default {
  components: {
    EarningStatistic,
  },
  props: {
    earningStats: {
      type: Object,
      default: () => {},
    },
    loadingEarningStats: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
